import React, { FC, Fragment, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import Heading from '../../../ui/heading/Heading';

interface IPublicationContainer {
  title: string;
  subtitle?: string;
  link?: string;
  children: ReactNode;
}

export const CompanyPagesContaner: FC<IPublicationContainer> = ({ title, link, children, subtitle }) => {
  return (
    <div className="publication-card">
      <div className="publication-card__wrapper">
        <div className="breadcrumbs">
          <div className="breadcrumbs__item--red">Главная</div>
          <div className="breadcrumbs__item--gray">/</div>
          {link && (
            <Fragment>
              <Link to={`/${link}`}>
                <div className="breadcrumbs__item--red">{subtitle}</div>
              </Link>
              <div className="breadcrumbs__item--gray">/</div>
            </Fragment>
          )}
          <div className="breadcrumbs__item--gray">{title}</div>
        </div>
        <Heading title={title} className="publication-card__title" />
        <div className="publication-card__content">{children}</div>
      </div>
    </div>
  );
};
